import React, {useState} from 'react';
import { Link, Navigate, useLocation } from "react-router-dom";
import LoginBg from '../images/stock.jpg';
import axios from 'axios';

const OtpConfirm =()=>{
     
    const location = useLocation();
    const passedData = location.state;

    const [msisdn, setMsisdn] = useState(passedData.msisdn); 
    const [code, setCode] = useState(''); 
    const [redirect, setRedirect] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    //console.log("MSISDN:" + passedData.msisdn)
    
    const checkOtp = async (e) =>{
        e.preventDefault();

        
        const {data} = await axios.post('checkOtp',{
            msisdn, 
            code,
        });

        
       // console.log(data.headers)
        
        const responseCode = data.response_code
        if(responseCode === "60042"){
            setErrorMessage(data.message);
        }

        if(responseCode === "0"){
            setErrorMessage(data.message);
            console.log("HEADERS:" + data.headers);
            setRedirect(true);
        }
        
 
        
    }
    if(redirect){
        return <Navigate to={'/'} />;
    }
   

    return (
        <>
        <form onSubmit={checkOtp}>
        <div className="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
      <div
        className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800"
      >
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <div className="h-32 md:h-auto md:w-1/2">
            <img
              aria-hidden="true"
              className="object-cover w-full h-full dark:hidden"
              src={LoginBg}
              alt="Office"
            />
            
          </div>
          
            <div className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
                <div className="w-full">
                <h1
                    className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200"
                >
                    Enter the OTP
                </h1>
               

                <label className={` block text-sm  ` }>
                    <span className="text-gray-700 dark:text-gray-400">OTP</span>
                    <input
                    className="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                    placeholder="00000" onChange={e => setCode(e.target.value) }
                    />
                </label>
               

                {/* <!-- You should use a button here, as the anchor is only used for the example  --> */}
                


                <button
                    className={`block w-full px-4 py-2 mt-4 text-sm font-medium leading-5 text-center text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-blue-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple`}
                    onClick={checkOtp}
                >
                    Login
                </button>

                <hr className="my-8" />
                {errorMessage}
                <p className="mt-4">
                    <Link
                    className="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                    to={"/subscribe"}
                    >
                    Subscribe!
                    </Link>
                </p>
                
                </div>
            </div>
          
           
        </div>
      </div>
    </div>
        </form>
         
        </>
    );
}

export default OtpConfirm;